// Utility function to detect Android devices
export const isAndroid = () => {
  return navigator.userAgent.toLowerCase().includes('android');
};

// Utility function to detect iOS devices (iPhone, iPad, iPod)
export const isIOS = () => {
  const ua = navigator.userAgent || navigator.vendor || '';
  const isAppleMobile = /iPad|iPhone|iPod/.test(ua);
  // iPadOS 13+ reports as "MacIntel" but exposes touch points
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return isAppleMobile || isIPadOS;
};
